import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import AuthProtectedRoutes from "../Components/Auth/AuthProtectedRoutes";
import AdminLayout from "../Layout/AdminLayout";
import Login from "../Pages/Auth/Login";
import Logout from "../Pages/Auth/Logout";
import CmsList from "../Pages/CMS/CmsList";
import CmsEdit from "../Pages/CMS/CmsEdit";
import EmptyPage from "../Pages/Empty";
import ManagerList from "../Pages/Manager/ManagerList";
import ManagerEdit from "../Pages/Manager/ManagerEdit";
import BranchList from "../Pages/Branch/BranchList";
import BranchEdit from "../Pages/Branch/BranchEdit";
import OrganizationList from "../Pages/Organization/OrganizationList";
import OrganizationEdit from "../Pages/Organization/OrganizationEdit";
import HomePreview from "../Pages/Dashboard/HomePreview";
import ExpirePreview from "../Pages/Dashboard/ExpirePreview";
import ActivityLog from "../Pages/Dashboard/ActivityLog";
import CategoryList from "../Pages/Category/CategoryList";
import CategoryEdit from "../Pages/Category/CategoryEdit";
import CmsItemList from "../Pages/CMS/CmsItemList";
import CmsItemEdit from "../Pages/CMS/CmsItemEdit";
import TemplateList from "../Pages/Template/TemplateList";
import TemplateEdit from "../Pages/Template/TemplateEdit";
import ShopByCategory from "../Pages/CMS/ShopByCategory";
import FooterConfig from "../Pages/SiteConfig/FooterConfig";
import TopRibbonConfig from "../Pages/SiteConfig/TopRibbonConfig";
import MissingImages from "../Pages/Reports/MissingImages";


function RoutesIndex() {
    return (<>
        <Router element>
            <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/logout" element={<Logout />} />

                <Route path="/" element={<AuthProtectedRoutes />}>
                    <Route element={<AdminLayout />}>
                        <Route path="" element={<EmptyPage />} />
                        <Route path="empty" element={<EmptyPage />} />

                        <Route path="template/list" element={<TemplateList />} />
                        <Route path="template/:action/:id?" element={<TemplateEdit />} />

                        <Route path="cms/shop_by_category" element={<ShopByCategory /> } />
                        <Route path="cms/:type/list" element={<CmsList />} />
                        <Route path="cms/:type/:action/:id?" element={<CmsEdit />} />

                        <Route path='cms_item/:cms_id/list' element={<CmsItemList />} />
                        <Route path='cms_item/:cms_id/:action/:id?' element={<CmsItemEdit />} />

                        <Route path="manager/list" element={<ManagerList />} />
                        <Route path="manager/:action/:id?" element={<ManagerEdit />} />

                        <Route path="branch/list" element={<BranchList />} />
                        <Route path="branch/:action/:id?" element={<BranchEdit />} />

                        <Route path="organization/list" element={<OrganizationList />} />
                        <Route path="organization/:action/:id?" element={<OrganizationEdit />} />

                        <Route path="category/list" element={<CategoryList />} />
                        <Route path="category/:action/:id?" element={<CategoryEdit />} />

                        <Route path="dashboard/home_preview" element={<HomePreview />} />
                        <Route path="dashboard/expire_preview" element={<ExpirePreview />} />
                        <Route path="dashboard/activity_log" element={<ActivityLog />} />

                        <Route path='reports/missing_images' element={<MissingImages />} />

                        <Route path='siteconfig/footer' element={<FooterConfig />} />
                        <Route path='siteconfig/top_ribbon' element={<TopRibbonConfig />} />

                    </Route>
                </Route>

                <Route path='*' element={<Navigate to={`/empty`} />} />
            </Routes>
        </Router>
    </>
    )
}

export default RoutesIndex;